import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { TweenMax, Quint } from 'gsap';

@Component({
	selector: 'app-modal-notice',
	templateUrl: './modal-notice.component.html',
	styleUrls: ['./modal-notice.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ModalNoticeComponent implements OnInit {

	constructor() { }

	@Input() title;

	@Input() text;

	@Input() text2;

	modalHidden = false;

	ngOnInit() {
	}

	openModalNotice() {
		this.modalHidden = false;

		$('[data-component="modal-notice"]').css('display', 'block');
	}

	closeModalNotice() {
		this.modalHidden = true;
		TweenMax.to('[data-component="modal-notice"] .modal', .5, {
			opacity: 0,
			autoAlpha: 0,
			bottom: '100%',
			ease: Quint.easeOut,
			onComplete: () => {
			}
		});
		$('[data-component="modal-notice"]').hide();
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-notice/modal-notice.component.ts